import React, { useState } from 'react';
import styled from 'styled-components';
import Title from '../../Components/Text/Title';
import emailjs from 'emailjs-com';

import partner_img1 from '../../Images/partner_img1.png';
import partner_img2 from '../../Images/partner_img2.png';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding-top: 180px;
  padding-bottom: 280px;
  background-color: #080B31;
`
const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 970px;
  position: relative;
  z-index: 10;
  justify-content: center;
  align-items: center;
  @media (max-width: 1010px) {
    width: 100%;
    padding: 0 20px;
  };
`
const ContentsContainer = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  & > form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    & > input {
      width: 770px;
      height: 45px;
      border: none;
      font-size: 16px;
      color: white;
      background-color: #252853;
      padding: 0 20px;
      @media (max-width: 810px) {
        width: 100%;
      };
    }
    & > input + input {
      margin-top: 15px;
    }
    & > textarea {
      margin-top: 15px;
      padding: 20px 20px;
      height: 160px;
      width: 770px;
      background-color: #252853;
      border: none;
      font-size: 16px;
      color: white;
      resize: none;
      @media (max-width: 810px) {
        width: 100%;
      };
    }
  }
`
const ContactsButton = styled.button`
  margin-top: 30px;
  width: 240px;
  height: 45px;
  background-color: #FF8E00;
  font-size: 16px;
  font-weight: 800;
  color: #212121;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
`

const ContactsContainer = ({ language, modal }) => {
  const [userEmail, setUserEmail] = useState("");
  const [from_name, setFrom_name] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const onSubmit = (e) => {
    e.preventDefault()// Prevents default refresh by the browser
    if (userEmail) {
      emailjs.sendForm('service_cd1hpa9', 'template_ma2raub', e.target, 'user_TgY2fDZQstZpxN6364qUm')
        .then(result => {
          alert('ok')
          modal.setValue(true);
          setUserEmail("");
          setFrom_name("");
          setPhone("");
          setMessage("");
        },
          error => {
            alert('An error occured, Plese try again', error.text)
          })
    }
  }

  return (
    <Container>
      <SubContainer>
        <Title
          text={'Contact'}
          color={'yellow'}
        />
        <ContentsContainer>
          <form onSubmit={onSubmit}>
            <input placeholder={language === "Korean" ? "회사명/이름" : "Company / Name"} name="from_name" onChange={(e) => { setFrom_name(e.target.value) }} value={from_name} />
            <input placeholder={language === "Korean" ? "이메일" : "Email"} type="email" name="userEmail" onChange={(e) => { setUserEmail(e.target.value) }} value={userEmail} />
            <input placeholder={language === "Korean" ? "연락처" : "Phone"} name="phone" onChange={(e) => { setPhone(e.target.value) }} value={phone} />
            <textarea placeholder={language === "Korean" ? "내용" : "Contents"} name="message" onChange={(e) => { setMessage(e.target.value) }} value={message} />
            <ContactsButton type='submit' >SEND</ContactsButton>
          </form>
        </ContentsContainer>
      </SubContainer>
    </Container>
  )
}

export default ContactsContainer;